import React, { createContext, useContext, useState, useEffect } from "react";
import api from "../services/api";
import { resetEcho } from '../services/echo';

const AuthContext = createContext(); // ← was missing

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("token"));
  const [user, setUser]   = useState(() => {
    const saved = localStorage.getItem("user");
    return saved ? JSON.parse(saved) : null;
  });

  useEffect(() => {
    if (!token) return;
    api.get("/me")
      .then((res) => {
        const updated = res.data;
        localStorage.setItem("user", JSON.stringify(updated));
        setUser(updated);
      })
      .catch(() => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        setToken(null);
        setUser(null);
      });
  }, [token]);

  useEffect(() => {
  if (token) {
    resetEcho(); // Clear any stale instance
    // Echo will be recreated with fresh token on next getEcho() call
  }
  }, [token]);

  const login = (tkn, usr) => {
    localStorage.setItem("token", tkn);
    localStorage.setItem("user", JSON.stringify(usr));
    setToken(tkn);
    setUser(usr);
    resetEcho();
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setToken(null);
    setUser(null);
    resetEcho();
  };

  const refreshUser = async () => {
    try {
      const res     = await api.get("/me");
      const updated = res.data;
      localStorage.setItem("user", JSON.stringify(updated));
      setUser(updated);
      return updated;
    } catch {
      return null;
    }
  };

  return (
    <AuthContext.Provider value={{ token, user, login, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() { // ← was missing
  return useContext(AuthContext);
}